<template>
	<div>
		<!-- <h2 class="mb-4">Conteggi {{ bando?.nome }} con ID {{ bando?.id }}</h2> -->

		<v-overlay :value="loading" absolute>
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-simple-table>
			<template v-slot:default>
				<thead>
					<tr>
						<th class="text-left">Account Manager</th>
						<th class="text-center">Pratiche</th>
						<th class="text-center">Contratti Firmati</th>
						<th class="text-center">Moduli Riepilogo</th>
						<th class="text-center">Moduli Codice ClickDay</th>
						<th class="text-center">Moduli + PEC + Num. Emergenza</th>
						<th class="text-center">Fase 1 Completata</th>
						<th class="text-center">Fase 2 Completata</th>
						<th class="text-center">Fase 3 Completata</th>
						<th class="text-center">Fase 4 Completata</th>
						<th class="text-center">Fase 5 Completata</th>
						<th class="text-center">Fase 6 Completata</th>
						<th class="text-center">Fase 7 Completata</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in conteggi" :key="item.id">
						<td><strong>{{ item.nome_cognome }}</strong></td>
						<td class="text-center">{{ item.pratiche }}</td>
						<td class="text-center">{{ item.contratti_associati }}</td>
						<td class="text-center">{{ item.moduli_riepilogo_caricati }}</td>
						<td class="text-center">{{ item.moduli_codice_clickday_caricati }}</td>
						<td class="text-center">{{ item.moduli_pec_numeri_emergenza_caricati_contemporaneamente }}</td>
						<td class="text-center">{{ item.fase_1_completata }}</td>
						<td class="text-center">{{ item.fase_2_completata }}</td>
						<td class="text-center">{{ item.fase_3_completata }}</td>
						<td class="text-center">{{ item.fase_4_completata }}</td>
						<td class="text-center">{{ item.fase_5_completata }}</td>
						<td class="text-center">{{ item.fase_6_completata }}</td>
						<td class="text-center">{{ item.fase_7_completata }}</td>
					</tr>
				</tbody>
				<tfoot>
					<!-- Riga Totali -->
					<tr :class="['font-weight-bold', 'blue-grey', $vuetify.theme.dark ? 'darken-2' : 'lighten-5']">
						<td class="text-left">TOTALE</td>
						<td class="text-center">{{ totali.pratiche }}</td>
						<td class="text-center">{{ totali.contratti_associati }}</td>
						<td class="text-center">{{ totali.moduli_riepilogo_caricati }}</td>
						<td class="text-center">{{ totali.moduli_codice_clickday_caricati }}</td>
						<td class="text-center">{{ totali.moduli_pec_numeri_emergenza_caricati_contemporaneamente }}</td>
						<td class="text-center">{{ totali.fase_1_completata }}</td>
						<td class="text-center">{{ totali.fase_2_completata }}</td>
						<td class="text-center">{{ totali.fase_3_completata }}</td>
						<td class="text-center">{{ totali.fase_4_completata }}</td>
						<td class="text-center">{{ totali.fase_5_completata }}</td>
						<td class="text-center">{{ totali.fase_6_completata }}</td>
						<td class="text-center">{{ totali.fase_7_completata }}</td>
					</tr>
				<!-- Riga Percentuali dei Totali -->
					<tr :class="['font-weight-bold', 'success', $vuetify.theme.dark ? 'darken-2' : 'lighten-4']">
						<td class="text-left">% TOTALE</td>
						<td class="text-center">-</td>
						<td class="text-center">{{ percentualiDeiTotali.contratti_associati }}%</td>
						<td class="text-center">{{ percentualiDeiTotali.moduli_riepilogo_caricati }}%</td>
						<td class="text-center">{{ percentualiDeiTotali.moduli_codice_clickday_caricati }}%</td>
						<td class="text-center">{{ percentualiDeiTotali.moduli_pec_numeri_emergenza_caricati_contemporaneamente }}%</td>
						<td class="text-center">{{ percentualiDeiTotali.fase_1_completata }}%</td>
						<td class="text-center">{{ percentualiDeiTotali.fase_2_completata }}%</td>
						<td class="text-center">{{ percentualiDeiTotali.fase_3_completata }}%</td>
						<td class="text-center">{{ percentualiDeiTotali.fase_4_completata }}%</td>
						<td class="text-center">{{ percentualiDeiTotali.fase_5_completata }}%</td>
						<td class="text-center">{{ percentualiDeiTotali.fase_6_completata }}%</td>
						<td class="text-center">{{ percentualiDeiTotali.fase_7_completata }}%</td>
					</tr>
										<!-- Riga Numero Mancanti -->
					<tr :class="['font-weight-bold', 'warning', $vuetify.theme.dark ? 'darken-2' : 'lighten-3']">
						<td class="text-left">MANCANTI</td>
						<td class="text-center">-</td>
						<td class="text-center">{{ mancanti.contratti_associati }}</td>
						<td class="text-center">{{ mancanti.moduli_riepilogo_caricati }}</td>
						<td class="text-center">{{ mancanti.moduli_codice_clickday_caricati }}</td>
						<td class="text-center">{{ mancanti.moduli_pec_numeri_emergenza_caricati_contemporaneamente }}</td>
						<td class="text-center">{{ mancanti.fase_1_completata }}</td>
						<td class="text-center">{{ mancanti.fase_2_completata }}</td>
						<td class="text-center">{{ mancanti.fase_3_completata }}</td>
						<td class="text-center">{{ mancanti.fase_4_completata }}</td>
						<td class="text-center">{{ mancanti.fase_5_completata }}</td>
						<td class="text-center">{{ mancanti.fase_6_completata }}</td>
						<td class="text-center">{{ mancanti.fase_7_completata }}</td>
										<!-- Riga Percentuali Mancanti -->
					<tr :class="['font-weight-bold', 'error', $vuetify.theme.dark ? 'darken-2' : 'lighten-4']">
						<td class="text-left">% MANCANTI</td>
						<td class="text-center">-</td>
						<td class="text-center">{{ percentualiMancanti.contratti_associati }}%</td>
						<td class="text-center">{{ percentualiMancanti.moduli_riepilogo_caricati }}%</td>
						<td class="text-center">{{ percentualiMancanti.moduli_codice_clickday_caricati }}%</td>
						<td class="text-center">{{ percentualiMancanti.moduli_pec_numeri_emergenza_caricati_contemporaneamente }}%</td>
						<td class="text-center">{{ percentualiMancanti.fase_1_completata }}%</td>
						<td class="text-center">{{ percentualiMancanti.fase_2_completata }}%</td>
						<td class="text-center">{{ percentualiMancanti.fase_3_completata }}%</td>
						<td class="text-center">{{ percentualiMancanti.fase_4_completata }}%</td>
						<td class="text-center">{{ percentualiMancanti.fase_5_completata }}%</td>
						<td class="text-center">{{ percentualiMancanti.fase_6_completata }}%</td>
						<td class="text-center">{{ percentualiMancanti.fase_7_completata }}%</td>
					</tr>
				</tfoot>
			</template>
		</v-simple-table>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	data() {
		return {
			conteggi: [],
			loading: false,
		};
	},
	
	computed: {
		...mapGetters({
			bando: 'shared/bando',
		}),
		
		totali() {
			if (!this.conteggi.length) {
				return {
					pratiche: 0,
					contratti_associati: 0,
					moduli_riepilogo_caricati: 0,
					moduli_codice_clickday_caricati: 0,
					moduli_pec_numeri_emergenza_caricati_contemporaneamente: 0,
					fase_1_completata: 0,
					fase_2_completata: 0,
					fase_3_completata: 0,
					fase_4_completata: 0,
					fase_5_completata: 0,
					fase_6_completata: 0,
					fase_7_completata: 0,
				};
			}
			
			return {
				// reduce() itera su tutti gli elementi dell'array conteggi:
				// - parte da 0 (valore iniziale)
				// - per ogni item, somma il valore della proprietà al totale accumulato (sum)
				// - restituisce la somma finale di tutti i valori
				pratiche: this.conteggi.reduce((sum, item) => sum + item.pratiche, 0),
				contratti_associati: this.conteggi.reduce((sum, item) => sum + item.contratti_associati, 0),
				moduli_riepilogo_caricati: this.conteggi.reduce((sum, item) => sum + item.moduli_riepilogo_caricati, 0),
				moduli_codice_clickday_caricati: this.conteggi.reduce((sum, item) => sum + item.moduli_codice_clickday_caricati, 0),
				moduli_pec_numeri_emergenza_caricati_contemporaneamente: this.conteggi.reduce((sum, item) => sum + item.moduli_pec_numeri_emergenza_caricati_contemporaneamente, 0),
				fase_1_completata: this.conteggi.reduce((sum, item) => sum + item.fase_1_completata, 0),
				fase_2_completata: this.conteggi.reduce((sum, item) => sum + item.fase_2_completata, 0),
				fase_3_completata: this.conteggi.reduce((sum, item) => sum + item.fase_3_completata, 0),
				fase_4_completata: this.conteggi.reduce((sum, item) => sum + item.fase_4_completata, 0),
				fase_5_completata: this.conteggi.reduce((sum, item) => sum + item.fase_5_completata, 0),
				fase_6_completata: this.conteggi.reduce((sum, item) => sum + item.fase_6_completata, 0),
				fase_7_completata: this.conteggi.reduce((sum, item) => sum + item.fase_7_completata, 0),
			};
		},
		
		percentualiDeiTotali() {
			const totalePratiche = this.totali.pratiche;
			
			if (totalePratiche === 0) {
				return {
					contratti_associati: 0,
					moduli_riepilogo_caricati: 0,
					moduli_codice_clickday_caricati: 0,
					moduli_pec_numeri_emergenza_caricati_contemporaneamente: 0,
					fase_1_completata: 0,
					fase_2_completata: 0,
					fase_3_completata: 0,
					fase_4_completata: 0,
					fase_5_completata: 0,
					fase_6_completata: 0,
					fase_7_completata: 0,
				};
			}
			
			return {
				contratti_associati: ((this.totali.contratti_associati / totalePratiche) * 100).toFixed(2),
				moduli_riepilogo_caricati: ((this.totali.moduli_riepilogo_caricati / totalePratiche) * 100).toFixed(2),
				moduli_codice_clickday_caricati: ((this.totali.moduli_codice_clickday_caricati / totalePratiche) * 100).toFixed(2),
				moduli_pec_numeri_emergenza_caricati_contemporaneamente: ((this.totali.moduli_pec_numeri_emergenza_caricati_contemporaneamente / totalePratiche) * 100).toFixed(2),
				fase_1_completata: ((this.totali.fase_1_completata / totalePratiche) * 100).toFixed(2),
				fase_2_completata: ((this.totali.fase_2_completata / totalePratiche) * 100).toFixed(2),
				fase_3_completata: ((this.totali.fase_3_completata / totalePratiche) * 100).toFixed(2),
				fase_4_completata: ((this.totali.fase_4_completata / totalePratiche) * 100).toFixed(2),
				fase_5_completata: ((this.totali.fase_5_completata / totalePratiche) * 100).toFixed(2),
				fase_6_completata: ((this.totali.fase_6_completata / totalePratiche) * 100).toFixed(2),
				fase_7_completata: ((this.totali.fase_7_completata / totalePratiche) * 100).toFixed(2),
			};
		},
		
		mancanti() {
			const totalePratiche = this.totali.pratiche;
			
			return {
				contratti_associati: totalePratiche - this.totali.contratti_associati,
				moduli_riepilogo_caricati: totalePratiche - this.totali.moduli_riepilogo_caricati,
				moduli_codice_clickday_caricati: totalePratiche - this.totali.moduli_codice_clickday_caricati,
				moduli_pec_numeri_emergenza_caricati_contemporaneamente: totalePratiche - this.totali.moduli_pec_numeri_emergenza_caricati_contemporaneamente,
				fase_1_completata: totalePratiche - this.totali.fase_1_completata,
				fase_2_completata: totalePratiche - this.totali.fase_2_completata,
				fase_3_completata: totalePratiche - this.totali.fase_3_completata,
				fase_4_completata: totalePratiche - this.totali.fase_4_completata,
				fase_5_completata: totalePratiche - this.totali.fase_5_completata,
				fase_6_completata: totalePratiche - this.totali.fase_6_completata,
				fase_7_completata: totalePratiche - this.totali.fase_7_completata,
			};
		},
		
		percentualiMancanti() {
			return {
				contratti_associati: (100 - parseFloat(this.percentualiDeiTotali.contratti_associati)).toFixed(2),
				moduli_riepilogo_caricati: (100 - parseFloat(this.percentualiDeiTotali.moduli_riepilogo_caricati)).toFixed(2),
				moduli_codice_clickday_caricati: (100 - parseFloat(this.percentualiDeiTotali.moduli_codice_clickday_caricati)).toFixed(2),
				moduli_pec_numeri_emergenza_caricati_contemporaneamente: (100 - parseFloat(this.percentualiDeiTotali.moduli_pec_numeri_emergenza_caricati_contemporaneamente)).toFixed(2),
				fase_1_completata: (100 - parseFloat(this.percentualiDeiTotali.fase_1_completata)).toFixed(2),
				fase_2_completata: (100 - parseFloat(this.percentualiDeiTotali.fase_2_completata)).toFixed(2),
				fase_3_completata: (100 - parseFloat(this.percentualiDeiTotali.fase_3_completata)).toFixed(2),
				fase_4_completata: (100 - parseFloat(this.percentualiDeiTotali.fase_4_completata)).toFixed(2),
				fase_5_completata: (100 - parseFloat(this.percentualiDeiTotali.fase_5_completata)).toFixed(2),
				fase_6_completata: (100 - parseFloat(this.percentualiDeiTotali.fase_6_completata)).toFixed(2),
				fase_7_completata: (100 - parseFloat(this.percentualiDeiTotali.fase_7_completata)).toFixed(2),
			};
		},
	},
	
	mounted() {
		this.fetchConteggi();
	},
	
	methods: {
		fetchConteggi() {
			this.loading = true;
			axios.get(`/api/bandi/${this.bando.id}/conteggi`)
				.then(response => {
					this.conteggi = response.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
	},
};
</script>